/**
 * Registers public/sw.js — the offline-fallback-only worker that makes the
 * app installable. Production builds only: a worker on the dev server would
 * sit between the developer and hot reload.
 */
export function registerServiceWorker(): void {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Non-fatal: the app works the same without it; only install and the
      // offline page are lost.
    });
  });
}
